export default __webpack_public_path__ + "static/B0105-3c7d5d0ecc53534368454d4038885192.png";